import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { Location16 } from '@carbon/icons-react';
import isNil from 'lodash/isNil';
import round from 'lodash/round';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

export interface DealerLocationInfoProps {
  dealer: SchemaTypes.Dealer | null;
  displayDealerName?: boolean;
}

const DealerLocationInfo: FC<DealerLocationInfoProps> = (props) => {
  const intl = useIntl();

  const { dealer, displayDealerName = false } = props;
  const { name, distance, location } = dealer ?? {};
  const { city, houseNumber, street, zip, additionalAddress } = location ?? {};

  const className = {
    name: 'mb-5 lg:mb-15px',
    location: 'flex items-center mt-5px md:mt-15px',
    locationIcon: 'mr-5px',
    content: 'ml-30px',
  };

  return (
    <div className={className.content}>
      {displayDealerName && name && (
        <div className={className.name}>{name}</div>
      )}
      {location && (
        <div>
          {street && (
            <div>
              {street} {houseNumber}
            </div>
          )}
          {additionalAddress && <div>{additionalAddress}</div>}
          {zip && city && (
            <div>
              {zip} {city}
            </div>
          )}
        </div>
      )}

      {!isNil(distance) && (
        <div className={className.location}>
          <Location16 className={className.locationIcon} />
          <div>
            {translate(intl, 'ui.DEALER_FINDER.DISTANCE_TEXT', {
              value: intl.formatNumber(round(distance, 1)),
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default DealerLocationInfo;
